import BatchDashboardReducer from "../redux/BatchDashboardSlice";
import BatchDetailReducer from "../redux/BatchDetailSlice";
import DistributorSuggestionsReducer from "../redux/DistributorSuggestionsSlice";
import OverrideHistoryReducer from "../redux/OverrideHistorySlice";
import ReplenishmentOrdersReducer from "../redux/ReplenishmentOrdersSlice";
import LearningTrustScoreReducer from "../redux/LearningTrustScoreSlice";
import CalculationLogsReducer from "../redux/CalculationLogsSlice";
import DistributorSkuSummaryReducer from "../redux/DistributorSkuSummarySlice";
import PendingApprovalsReducer from "../redux/PendingApprovalsSlice";

export const BatchDashboardSlice = BatchDashboardReducer;
export const BatchDetailSlice = BatchDetailReducer;
export const DistributorSuggestionsSlice = DistributorSuggestionsReducer;
export const OverrideHistorySlice = OverrideHistoryReducer;
export const ReplenishmentOrdersSlice = ReplenishmentOrdersReducer;
export const LearningTrustScoreSlice = LearningTrustScoreReducer;
export const CalculationLogsSlice = CalculationLogsReducer;
export const DistributorSkuSummarySlice = DistributorSkuSummaryReducer;
export const PendingApprovalsSlice = PendingApprovalsReducer;
